const USER_TYPES = {
  PERSON: 'person',
  UNIPERSONAL: 'unipersonal',
  COMPANY: 'company',
};

const isEditable = user => (
  user.state !== 1 && user.state !== 2
);

class User {
  constructor(params) {
    this.id = params.id;
    this.type = params.type;
    this.email = params.email;
    this.showCredit = params.showCredit;
    this.isEditable = isEditable(params);
    this.isPartiallyEditable = !isEditable(params);
    this.canNoPayWithBank = params.canNoPayWithBank;
    if (this.type === USER_TYPES.COMPANY) {
      this.tradeName = params.tradeName;
      this.rut = params.rut;
      this.fictitiousName = params.fictitiousName;
    } else {
      this.names = params.names;
      this.surnames = params.surnames;
      this.documentCountry = params.documentCountry;
      this.document = params.document;
      this.rut = params.rut;
    }
  }

  get userName() {
    if (this.type === USER_TYPES.COMPANY) {
      return this.tradeName;
    }
    return `${this.names} ${this.surnames}`.trim();
  }
}

export { User, USER_TYPES };



// WEBPACK FOOTER //
// ./src/models/User.js